
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import {
  CommunityQmiDetails, HeaderData, NeighboorhoodCoords, NeighborhoodInfo, NeighborhoodPlanQmiCounts, NeighborhoodPlatMap, NeighborhoodSoldDetails, QmiDays, SidebarHomePlan, planDetails,
} from "../types";
import AppHeaderBreadcrumb from "./AppHeaderBreadCrumb.vue";
import NeighborhoodList from "./AppHeaderNeighborhoodList.vue";
import AppHeaderCommunityDetails from "./AppHeaderCommunityDetails.vue";
import ArrowDownIcon from "@/assets/icons/ArrowDown.vue";
import { HomePlanSortOptions, QmiDaysFilter, Settings } from "@/constant";
import { isMobile, isTablet } from "mobile-device-detect";
@Component({
  components: {
    AppHeaderBreadcrumb,
    AppHeaderCommunityDetails,
    NeighborhoodList,
    ArrowDownIcon,
  },
})
export default class PlatmapHeader extends Vue {
  $refs!: any;
  private qmiFilter = false;
  private qmiFilterList = [] as QmiDays[];
  private initialQmiFilterList = [] as QmiDays[];
  private hideSortQmiOption = false;
  private isAnyFilterApplied = false;
  @Prop() coordinates: NeighborhoodPlatMap[];
  @Prop() private qmiDetails!:CommunityQmiDetails;
  @Prop() headerData!: HeaderData;
  @Prop() availableSites!: number;
  @Prop() availablePlans!: number;
  @Prop() isKioskMode!: boolean;
  @Prop() messages: any;
  @Prop() selectedLotId!: string;
  @Prop() selectedLotStatus!: string;
  @Prop() neighborhoods!: NeighborhoodInfo[];
  @Prop() selectedNeighborhoodIds!: string[];
  @Prop() planPriceExsist!: boolean;
  @Prop() selectedSorting!: string;
  @Prop() qmiAndHomeplans!: any[];
  @Prop() availableLots!:number;
  @Prop() soldPercentage!: NeighborhoodSoldDetails[];
  @Prop() neighborhoodsPlanQmiCount!: NeighborhoodPlanQmiCounts[];
  @Prop() communityHomePlans!: SidebarHomePlan[];
  @Prop() initialHomePlanCount!: number;
  @Prop() filterQmiCount!: number;
  @Prop() qmiAppliedMobile!: boolean;
  @Prop() sidebarOpen!: boolean;
  @Prop() homeTypeCount!: number;
  @Prop() totalMobileFilterApplied!: number;
  sortDropdown = false;
  qmiDaysFilterDropdown=false;
  homePlanSortOptions = HomePlanSortOptions;
  qmiDaysFilter=QmiDaysFilter;
  private hasMobile = !!(isMobile && !isTablet);
  @Emit("sethoverNeighborZoomLevel")sethoverNeighborZoomLevel(zoomLevel: number, isDisableHoverNeighbor: boolean, centerMap: NeighboorhoodCoords){}
  @Emit("loadNeighborhood") loadNeighborhood(
    areaName: string,
    communityName: string,
    neighborhoodName: string
  ) {}
  @Emit("hideSibling")hideSibling(){}
  @Emit('highlightNeighborhood')highlightNeighborhood(neighborhoodId: string, display: string){}
  @Emit("selectNeighborhood") selectNeighborhood(neighborhodId: string) {}
  @Emit("closeLotInfo") closeLotInfo() {}
  @Emit("setSorting") setSorting(option: any) {}
  @Emit("filterPlanNameHomeType") filterPlanNameHomeType(
    listHomeType: string[],
    listPlanName: string[],
    maxPrice: number,
    minPrice: number
  ) {
      this.isAnyFilterApplied = !!listHomeType.length || !!listPlanName.length || maxPrice !== Settings.MaxValue || minPrice !== Settings.MinValue;
  }
  @Emit("applyMobilePriceFilter") applyMobilePriceFilter(minValue: number,maxValue: number){}
  @Emit("applyMobileFilters")applyMobileFilters(listPlanName:string[],listHomeType:string[],qmiFilterList:QmiDays[]){}
  @Emit("toggleshowFilters")toggleshowFilters(){}
  @Emit("setPlanNameListId") setPlanNameListId(listPlanNameId: string[]) {}
  @Emit("clearSelectedNeighborhoods") clearSelectedNeighborhoods() {
    this.$refs.platmapCommunityDetails.clearAllFilters();
  }
  @Emit("showQmiHomeplans")showQmiHomeplans(qmiFilter:boolean){}
  @Emit("applyQmiDaysFilter")applyQmiDaysFilter(qmFilterList: QmiDays[]){}
  @Emit("clearQmiDaysFilter")clearQmiDaysFilter(isQmiSelected:boolean){}
  @Emit("setPlanDetailsHometypeList")setPlanDetailsHometypeList(communityHomePlans: SidebarHomePlan[],homeTypeList: Set<string>,minPrice: number,maxPrice: number){}
  @Watch("changeQmifilterSelectedNeighborhoodIds") filterQmiDetails(oldVal,newVal)
  {
    if(!this.qmiFilterList.length){
      this.showQmiHomeplans(this.qmiFilter)
    }
    if(this.qmiFilter && !this.qmiFilterList.length){
      this.qmiFilterList=this.qmiDaysFilter;
      this.initialQmiFilterList = this.qmiDaysFilter;
      this.applyMoveInDaysFilter();
    }else if(!this.qmiFilter){
      this.qmiFilterList=[];
      this.initialQmiFilterList = [];
      this.showQmiHomeplans(false)
    }else{
      this.applyMoveInDaysFilter();
    }
  }

  @Watch("soldPercentage") checkSoldFilters () {
    this.checkSubFilters();
  }

  @Watch("selectedNeighborhoodIds") checkFilters () {
    this.checkSubFilters();
  }

  @Watch("sidebarOpen")legendToggleSidebar(){
    if(this.hasMobile)
    {
      document.getElementsByClassName('new-panarea')[0].addEventListener('touchstart',()=>{
        this.toggleshowFilters()})
    }
  }

  mounted() {
    this.checkSubFilters();
      if(this.hasMobile)
      {
        document.getElementsByClassName('new-panarea')[0].addEventListener('touchstart',()=>{
        this.toggleshowFilters()})
      }
  }
  
  get changeQmifilterSelectedNeighborhoodIds()
  {
    return `${this.qmiFilter} ${this.selectedNeighborhoodIds}`;
  }

  get disableSortQmiFilter(){
    if (!this.selectedNeighborhoodIds.length) {
      const totalLots = this.soldPercentage.filter((eachSoldPercentage) => !eachSoldPercentage.totalLotsCount)
      return !this.initialHomePlanCount || totalLots.length === this.soldPercentage.length;
    } else {
      const currentNeighborhoodTotalCount = this.soldPercentage.filter((eachSoldPercentage)=> eachSoldPercentage.neighborhoodId === this.selectedNeighborhoodIds[0])
      return !this.initialHomePlanCount || !currentNeighborhoodTotalCount[0]?.totalLotsCount;
    }
  }
  created() {
    window.addEventListener("click", this.hideDropDown);
  }
  beforeDestroy() {
    window.removeEventListener("click", this.hideDropDown);
  }
  toggleDropdownVisibility() {
    if(!this.disableSortQmiFilter)
      this.sortDropdown = !this.sortDropdown;
  }

  closeQmiFilter(){
    this.qmiDaysFilterDropdown = !this.qmiDaysFilterDropdown;
    this.qmiFilterList = this.initialQmiFilterList;
  }

  qmiFilterUpdate() {
    if(!this.qmiFilter) {
      this.qmiFilterList = [];
    }
  }
  hideDropDown(e: Event) {
    const dropdown = document.querySelector(".sort-price-container");
    const qmiFilterdropdown = document.querySelector(".qmi-filter");
    if (dropdown && !dropdown.contains(e.target as Node)) {
      this.sortDropdown = false;
    }
    if(qmiFilterdropdown && !qmiFilterdropdown.contains(e.target as Node))
    {
      this.qmiFilterList = this.initialQmiFilterList;
      this.qmiDaysFilterDropdown = false;
    }
  }
  applyMoveInDaysFilter()
  {
    if(this.qmiFilterList.length){
      this.qmiFilter=true;
      this.qmiDaysFilterDropdown = false;
      this.initialQmiFilterList = this.qmiFilterList;
      this.applyQmiDaysFilter(this.qmiFilterList);
    }
  }
  checkSubFilters() {
    this.hideSortQmiOption = false;
    if (this.selectedNeighborhoodIds.length) {
      const currentNeighborhoodData = this.soldPercentage.find(((neighborhood) => neighborhood.neighborhoodId === this.selectedNeighborhoodIds[0]));
      if (currentNeighborhoodData) {
        this.hideSortQmiOption =  !!(currentNeighborhoodData.totalLotsCount === 0 || this.initialHomePlanCount === 0);
      } else {
        this.hideSortQmiOption = true;
      }
    } else {
      if (this.soldPercentage.length !== this.neighborhoods.length) {
        this.hideSortQmiOption = true;
      } else {
        // this.soldPercentage.forEach((neighborhood) => {
        //   if (!neighborhood.totalLotsCount || neighborhood.totalLotsCount === 0 || this.qmiAndHomeplans.length === 0) {
        //     this.hideSortQmiOption = true;
        //   }
        // });
        const lotsHomePlans = this.soldPercentage.find((neighborhood)=> neighborhood.totalLotsCount && this.initialHomePlanCount);
        this.hideSortQmiOption = !lotsHomePlans;
      }
    }
  }
  clearMoveInDaysFilter()
  {
    this.qmiFilterList = [];
    this.initialQmiFilterList = [];
    this.qmiFilter=false;
    this.clearQmiDaysFilter(this.qmiFilter);
  }
  applyUrlQmi(qmiDays: QmiDays[]){
    this.qmiFilter = true;
    this.qmiFilterList = qmiDays;
    this.applyQmiDaysFilter(qmiDays);
  }
}
